import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
  AccountCircle,
  RememberMe,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import PasswordRounded from "@mui/icons-material/PasswordRounded";
import { useSnackbar } from "notistack";
import { Link, useNavigate } from "react-router-dom";
import {
  createIdentityAPIEndpoint,
  EndPoints,
} from "../../../services/AuthServices";
import useAuthContext from "../../../context/AuthContext";
import Img from "../../../assets/logo.png";

const InitialValues = {
  UserName: "",
  Password: "",
  RememberMe: false,
};
function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [values, setValues] = useState(InitialValues);
  const [formErrors, setFormErrors] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const { login } = useAuthContext();
  const { enqueueSnackbar } = useSnackbar();
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };
  const validate = (formValues) => {
    const errors = {};
    if (!formValues.UserName) errors.UserName = "من فضلك أدخل اسم المستخدم.";
    if (!formValues.Password) errors.Password = "من فضلك أدخل كلمة المرور.";

    return errors;
  };
  const resetForm = () => {
    setValues(InitialValues);
    setFormErrors({});
    setIsSubmit(false);
  };

  const handleLogin = async () => {
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("UserName", values.UserName);
      formData.append("Password", values.Password);
      formData.append("RememberMe", rememberMe);

      const res = await createIdentityAPIEndpoint(
        EndPoints.login,
      ).postWithOptions(formData, {
        withCredentials: true,
      });
      const { token } = res.data;
      const success = login(token);
      if (!success) throw new Error("Invalid access token");

      enqueueSnackbar("Login Success.", {
        variant: "success",
      });

      navigate("/");
    } catch (error) {
      enqueueSnackbar(
        error.response?.data?.message || "اسم المستخدم أو كلمة المرور غير صحيحة.",
        {
          variant: "error",
        },
      );
      resetForm();
    } finally {
      setLoading(false);
    }
  };
  const handleSubmitForm = async (e) => {
    e.preventDefault();

    const errors = validate(values);
    setFormErrors(errors);

    if (Object.keys(errors).length > 0) {
      return;
    }

    await handleLogin();
  };

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      className="login-page"
    >
      <Card elevation={0} className="login-card">
        <div className="login-logo">
          <h2>Pure<span>Eng</span> Academy</h2>
        </div>

        <CardContent className="login-content">
          <Typography variant="h4" component="h1" className="title_form">
            أهلاً بيك 👋
          </Typography>

          <Typography component="p" className="desc">
            سجّل دخولك لحسابك على PureEng
          </Typography>

          <form autoComplete="off" onSubmit={handleSubmitForm}>
            <Stack gap={2.5}>
              <FormControl variant="standard">
                <Input
                  placeholder="اسم المستخدم"
                  startAdornment={
                    <InputAdornment position="start">
                      <AccountCircle />
                    </InputAdornment>
                  }
                  onChange={handleChangeInput}
                  value={values.UserName}
                  name="UserName"
                  className="login-input"
                />

                <p className="p-error">{formErrors.UserName}</p>
              </FormControl>

              <FormControl variant="standard">
                <Input
                  placeholder="كلمة المرور"
                  type={showPassword ? "text" : "password"}
                  startAdornment={
                    <InputAdornment position="start">
                      <PasswordRounded />
                    </InputAdornment>
                  }
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="إظهار أو إخفاء كلمة المرور"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        onMouseUp={handleMouseUpPassword}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  onChange={handleChangeInput}
                  value={values.Password}
                  name="Password"
                  className="login-input"
                />

                <p className="p-error">{formErrors.Password}</p>
              </FormControl>

              <FormControlLabel
                className="remember-control"
                control={
                  <Checkbox
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                }
                label="تذكرني"
              />

              <Button
                type="submit"
                variant="contained"
                className="btn_submit"
                disabled={loading}
              >
                {loading ? "جاري تسجيل الدخول..." : "تسجيل الدخول"}
              </Button>
            </Stack>
          </form>

          <Typography component="p" className="back_home">
            مش عايز تسجّل دخول دلوقتي؟
            <Link to="/" className="dir_link">
              العودة للصفحة الرئيسية
            </Link>
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );
}

export default Login;
